import { Controller } from "@hotwired/stimulus"

// A row of chips led by "All" (the neighbourhoods of the creator's signup):
// ticking All ticks every chip, untick it and they all go; ticking the chips
// one by one ticks All once the last is in. The form also posts "All" itself,
// and the model reads it as every neighbourhood — the page works without this.
export default class extends Controller {
  static targets = ["all", "item"]

  connect() { this.sync() }

  toggleAll() {
    this.itemTargets.forEach((box) => { box.checked = this.allTarget.checked })
  }

  sync() {
    this.allTarget.checked = this.itemTargets.length > 0 && this.itemTargets.every((box) => box.checked)
  }
}
